
export default {
	staticURL: 'https://statics.tomexpress.jp/tomexpress',
	staticTOP: 'https://statics.tomexpress.jp',
}